import {
  saveRecord,
  saveRecords,
  getByValue,
  getByValues,
  getFilteredByMultiValue,
  getFilteredByValue,
  getFilteredByValues,
  remove,
  removeMultiple,
  patchRecord,
  patchRecords,
} from "../utils/array.repository.utils";
import { BaseClientRepository } from "./base.client.repository";
import { ClientService } from "../../services/client.service";

export class ArrayClientRepository<T> extends BaseClientRepository<T[]> {
  primaryKey: string;

  constructor(
    clientService: ClientService,
    accessor: string,
    primaryKey: string,
  ) {
    super(clientService, accessor);
    this.primaryKey = primaryKey;
  }

  private setter = (value: T[]) => super.set(value);

  public override get(): T[] {
    return super.get() || [];
  }

  public getAsArray(): T[] {
    return this.get();
  }

  public getAsMap(): { [key: string]: T } {
    const arr = this.get();
    return arr.reduce(
      (acc: any, item: any) => ({ ...acc, [item[this.primaryKey]]: item }),
      {},
    );
  }

  public getById(id: string): T {
    return this.getByValue(this.primaryKey, id);
  }

  public saveRecords(key: string | string[], records: T[]): Promise<T[]> {
    const previous = this.get();
    return saveRecords(key, records, this.setter, previous);
  }

  public saveRecord(key: string | string[], record: T): Promise<T> {
    const previous = this.get();
    return saveRecord(key, record, this.setter, previous);
  }

  public patchRecords(
    key: string | string[],
    value: any | any[],
    fieldsToPatch: Partial<T>,
  ): Promise<T[]> {
    const previous = this.get();
    return patchRecords(
      this.primaryKey,
      key,
      value,
      fieldsToPatch,
      this.setter,
      previous,
    );
  }

  public patchRecord(
    key: string | string[],
    value: any | any[],
    fieldsToPatch: Partial<T>,
  ): Promise<T> {
    const previous = this.get();
    return patchRecord(
      this.primaryKey,
      key,
      value,
      fieldsToPatch,
      this.setter,
      previous,
    );
  }

  public getLength(): number {
    const records = this.get();
    return records.length;
  }

  public getByValue(key: string, value: any): T {
    const records = this.get();
    return getByValue(key, value, records);
  }

  public getByValues(keys: string[], values: any[]): T {
    const records = this.get();
    return getByValues(keys, values, records);
  }

  public getFilteredByValue(key: string, value: any): T[] {
    const records = this.get();
    return getFilteredByValue(key, value, records);
  }

  public getFilteredByMultiValue(key: string, values: any[]): T[] {
    const records = this.get();
    return getFilteredByMultiValue(key, values, records);
  }

  public getFilteredByValues(keys: string[], values: any[]): T[] {
    const records = this.get();
    return getFilteredByValues(keys, values, records);
  }

  public remove(key: string, value: any): Promise<T[]> {
    const records = this.get();
    return remove(key, value, this.setter, records);
  }

  public removeMultiple(key: string, values: any[]): Promise<T[]> {
    const records = this.get();
    return removeMultiple(key, values, this.setter, records);
  }
}
